import { Box, Button, Stack, Typography } from "@mui/material";

interface LessonCompleteViewProps {
  title: string;
  description: string;
  primaryLabel: string;
  primaryHref: string;
  showRateLesson?: boolean;
  onRateLesson?: () => void;
}

const LessonCompleteView = ({
  title,
  description,
  primaryLabel,
  primaryHref,
  showRateLesson = false,
  onRateLesson,
}: LessonCompleteViewProps) => {
  return (
    <Box
      sx={(theme) => ({
        minHeight: "100vh",
        width: "100%",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: {
 xs: 2,
sm: 3 
},
        py: {
 xs: 4,
sm: 6 
},
      })}
    >
      <Stack
        alignItems="center"
        textAlign="center"
        spacing={3}
        sx={{
 width: "100%",
maxWidth: 520 
}}
      >
        <Box
          alt="Tutred"
          component="img"
          src="/images/logo.svg"
          sx={{
 width: {
 xs: 100,
sm: 120 
},
height: "auto" 
}}
        />

        <Typography
          component="h1"
          variant="text28B"
          sx={{ color: "secondary.main" }}
        >
          {title}
        </Typography>

        <Typography
          variant="text16R"
          sx={{
 color: "text.secondary",
maxWidth: 440 
}}
        >
          {description}
        </Typography>

        <Stack spacing={2} sx={{
 width: "100%",
maxWidth: 360,
pt: 1 
}}>
          {showRateLesson && onRateLesson ? (
            <Button
              type="button"
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={onRateLesson}
              sx={{
 borderRadius: "6px",
py: 1 
}}
            >
              Rate your lesson
            </Button>
          ) : null}
          <Button
            variant="contained"
            color="primary"
            href={primaryHref}
            fullWidth
            sx={{
              borderRadius: "6px",
              py: 1,
              boxShadow: "none",
              "&:hover": { boxShadow: "none" },
            }}
          >
            {primaryLabel}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default LessonCompleteView;
